import { Injectable, inject } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ActivityTrackingService {
  private router = inject(Router);

  public visitedPages: string[] = [];

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (event.urlAfterRedirects) {
        this.visitedPages = [event.urlAfterRedirects, ...this.visitedPages];
      }
    });
  }
}
